/* eslint-disable react/require-default-props */
import React from 'react';
import { Checkbox } from '../../inputs/Checkbox';
/**
 * CheckboxFilter
 * Inline toggle filter — no popup. Wraps the Quimby `Checkbox` molecule.
 * @version 1.0.0
 * @since 2026-05-04
 */
export function CheckboxFilter({ field, label, value, onChange, disabled = false, id }) {
    return (React.createElement(Checkbox, { id: id !== null && id !== void 0 ? id : `filter-checkbox-${field}`, checked: value, label: label, onChange: onChange, disabled: disabled }));
}
